// src/admin/components/FilterChipGroup.jsx
import React from 'react';

export default function FilterChipGroup({ options, value, onChange }) {
  function toggle(v) {
    const next = value.includes(v) ? value.filter(x => x !== v) : [...value, v];
    onChange(next);
  }
  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
      {options.map(opt => {
        const active = value.includes(opt.value);
        return (
          <button
            key={opt.value}
            type="button"
            onClick={() => toggle(opt.value)}
            style={{
              padding: '5px 10px', borderRadius: '999px',
              border: `1px solid ${active ? '#E8002D' : 'rgba(0,0,0,0.12)'}`,
              background: active ? 'rgba(232,0,45,0.08)' : '#fff',
              color: active ? '#E8002D' : '#3a3a3c',
              fontSize: '12px', fontWeight: active ? 600 : 400,
              cursor: 'pointer',
              fontFamily: "'DM Sans', sans-serif",
            }}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
